/** 12px Inter uchun bitta belgining o'rtacha kengligi (shrift o'lchamiga nisbatan). */
const AVERAGE_CHAR_RATIO = 0.55;

interface BarValueLabelXParams {
  /** Chiziqning boshlanish koordinatasi. */
  barX: number;
  barWidth: number;
  /** Chiziq ichiga yoziladigan nom. */
  name: string;
  fontSize?: number;
  /** Nom chiziq boshidan qancha surilgan. */
  insideOffset?: number;
  /** Qiymat bilan oldidagi element orasidagi masofa. */
  gap?: number;
}

/** Gorizontal diagrammada qiymat yorlig'ining x koordinatasi.
 *  Chiziq qisqa bo'lsa nom undan oshib ketadi — bunday holda qiymat
 *  chiziqdan emas, nomdan keyin chiqadi va ustma-ust tushmaydi. */
export const getBarValueLabelX = ({
  barX,
  barWidth,
  name,
  fontSize = 12,
  insideOffset = 8,
  gap = 8,
}: BarValueLabelXParams) => {
  const nameWidth = insideOffset + name.length * fontSize * AVERAGE_CHAR_RATIO;
  return barX + Math.max(barWidth, nameWidth) + gap;
};
